module.exports = __webpack_public_path__ + "static/hero-96331abacdb61c6953dad2a4cf4ea6f1.png";